import { defineSlotRecipe } from '@chakra-ui/react';

export const tableRecipe = defineSlotRecipe({
	slots: ['root', 'row'],
	variants: {
		variant: {
			elevated: {
				root: {
					bg: 'rgba(251, 249, 255, 1)',
					boxShadow: 'md',
				},
			},
			outline: {
				root: {
					bg: 'rgba(251, 249, 255, 1)',
					borderWidth: '1px',
					borderColor: 'border',
				},
			},
			subtle: {
				root: {
					bg: 'rgba(251, 249, 255, 1)',
				},
			},
		},
		striped: {
			true: {
				row: {
					'&:nth-of-type(odd) td': {
						bg: 'rgba(100, 55, 159, 0.06)',
					},
				},
			},
		},
	},

	defaultVariants: {
		variant: 'subtle',
	},
});
